// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../chorda-demo/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../chorda-demo/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rows > .row {\n  padding: 0.8rem 0;\n}", "",{"version":3,"sources":["webpack://./../chorda-bulma/src/styles/index.scss"],"names":[],"mappings":"AAGI;EACE,iBAAA;AAFN","sourcesContent":["\n\n.rows {\n    > .row {\n      padding: .8rem 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
